import apiClient from '@/services/axios'

export const getWarehouseTiktok = ({ channel_id, business_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/tiktok/integration/query/warehouse/map/list/${channel_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const checkTiktokSyncStockStatus = ({ business_id, channel_code, channel_id }) => {
  return apiClient({
    method: 'get',
    url: `channel/${channel_code}/product/query/${channel_id}/sync/latest-process`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const getTiktokWarehouseChannelList = ({ channel_id, business_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/tiktok/shop/query/${channel_id}/warehouse`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const adjusTiktoktMappingWarehouseChannel = ({ channel_id, business_id, data }) => {
  return apiClient({
    method: 'post',
    url: `/channel/tiktok/integration/${channel_id}/warehouse`,
    data,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const bindingTokopedia = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: 'channel/tiktok/integration/bind/tokopedia',
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const disconnectTiktokIntegration = ({ channel_id, business_id , shop_id}) => {
  return apiClient({
    method: 'put',
    url: 'channel/tiktok/integration/cmd/shop/disconnect',
    params: {
      channel_id,
      shop_id,
    },
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const getTiktokDetailChannel = ({ channel_id, business_id, signal }) => {
  return apiClient({
    method: 'get',
    url: `/channel/tiktok/shop/query/${channel_id}`,
    headers: {
      'Business-Id': business_id,
    },
    signal,
  })
}

export const getTiktokCancelOrReturnDetailOrder = ({ business_id, channel_code, channel_id, order_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/tiktok/order/query/cancel/cancel_or_return/${order_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const rejectTiktokCancelOrReturnOrder = ({ business_id, order_id, cancel_id, data }) => {
  return apiClient({
    method: 'post',
    url: `/channel/tiktok/order/cmd/cancel/reject/${order_id}/${cancel_id}`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const acceptTiktokCancelOrReturnOrder = ({ business_id, order_id, cancel_id }) => {
  return apiClient({
    method: 'post',
    url: `/channel/tiktok/order/cmd/cancel/accept/${order_id}/${cancel_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const mappingWarehouseTiktokChannel = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: `/channel/tiktok/shop/cmd/warehouse/map`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const unMappingWarehouseTiktokChannel = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: `/channel/tiktok/shop/cmd/warehouse/unmap`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const updateTiktokAutoAcceptPerWarehouse = ({ business_id, channel_code, channel_id, data }) => {
  return apiClient({
    method: 'put',
    url: `/channel/${channel_code}/shop/cmd/${channel_id}/warehouse`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const activateProductTiktokChannel = ({ business_id, product_id, channel_id }) => {
  return apiClient({
    method: 'post',
    url: `/channel/tiktok/product/cmd/${channel_id}/status/activate/${product_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const deactivateProductTiktokChannel = ({ business_id, product_id, channel_id }) => {
  return apiClient({
    method: 'post',
    url: `/channel/tiktok/product/cmd/${channel_id}/status/deactivate/${product_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const syncTiktokSingleProductChannel = ({ business_id, channel_id, product_id }) => {
  return apiClient({
    method: 'post',
    url: `/channel/tiktok/product/cmd/${channel_id}/sync/${product_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const getLatestTiktokProductChannelSyncStatus = ({ channel_id, business_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/tiktok/product/query/process/sync`,
    headers: {
      'Business-Id': business_id,
    },
    params: {
      channel_id,
    },
  })
}

export const getTiktokDetailOrderEligibleForCancel = ({ business_id, params }) => {
  return apiClient({
    method: 'get',
    url: `/channel/tiktok/order/query/cancel/parameters`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const cancelTiktokOrder = ({ business_id, params, data }) => {
  return apiClient({
    method: 'put',
    url: `/channel/tiktok/order/cmd/cancel`,
    headers: {
      'Business-Id': business_id,
    },
    params,
    data,
  })
}

export const getTiktokDetailStockChannel = ({ business_id, channel_id, product_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/tiktok/product/query/internal/${channel_id}/${product_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const updatePackageTiktok = ({ workspace_id, business_id, params }) => {
  return apiClient({
    method: 'post',
    url: `/channel/tiktok/order/cmd/updatepackage`,
    params,
  })
}

export const labelFetcherTiktok = ({ data }) => {
  return apiClient({
    method: 'post',
    url: `/channel/tiktok/order/cmd/label-fetcher`,
    data,
  })
}

export const channelAcceptTiktok = ({ workspace_id, business_id, user_id, params }) => {
  return apiClient({
    method: 'put',
    url: `/channel/tiktok/order/cmd/state/channel-accept`,
    params,
  })
}

export const getTiktokListHistoryStockProduct = ({ channel_id, business_id, params }) => {
  return apiClient({
    method: 'get',
    url: `/channel/tiktok/product/query/${channel_id}/history/stock`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}